module.exports = __webpack_public_path__ + "static/media/warning-step-icon.d44e0f54.svg";